import Typography from "@mui/material/Typography"
import React, { type ElementType } from "react"
import { getActivityIcon } from "@/constants/activity_icons"
import { DateTime } from "luxon"

interface ActivityBaseProps {
  activityKey: string
  icon?: ElementType
  text: React.ReactNode
  createdAt: string
  className?: string
  "data-testid"?: string
}

const ActivityBase = ({ activityKey, icon, text, createdAt, className, "data-testid": testId }: ActivityBaseProps) => {
  const IconComponent = icon || getActivityIcon(activityKey)
  const dateTime = DateTime.fromISO(createdAt)
  const timeDisplay = dateTime.toLocaleString(DateTime.TIME_24_SIMPLE)
  const relativeTime = dateTime.toRelative()

  return (
    <div
      data-testid={testId || "panel-activity-base-container"}
      className={`flex items-center space-x-3 p-4 ${className}`}
    >
      <div className="flex-shrink-0 mt-1">
        <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center">
          <IconComponent className="w-4 h-4 text-gray-600" />
        </div>
      </div>

      <div data-testid="panel-activity-base-text" className="flex-1 min-w-0">
        {!!text && (
          <Typography variant="body2" component="div" className="text-gray-600">
            {text}
          </Typography>
        )}
      </div>

      <div data-testid="panel-activity-base-time" className="flex-shrink-0 text-right">
        <div className="text-base font-medium text-gray-700">{timeDisplay}</div>
        <div className="text-xs text-gray-400">{relativeTime}</div>
      </div>
    </div>
  )
}

export default ActivityBase
